import { getAPIPath, requestGooseAPI } from '../shared/request'
import type { InvoiceClientDto } from '../types/api'
import { CLIENT_INVOICES_BY_PERIOD } from '../types/constants'
import type { TOrderSearchOptions } from '../types/general'

export const ClientInvoicesByPeriodService = {
  getData: (
    locationName: string,
    options: TOrderSearchOptions
  ): Promise<{ results: InvoiceClientDto[]; nextToken: string | null }> => {
    const includesList = new Set(['location', 'period', 'locationServiceType.serviceType'])
    options.includes?.forEach((include) => includesList.add(include))
    const includeShared = options.hasSharedCRM

    if (options.hasSharedCRM) {
      includesList.add('location.delegateLocation')
    }
    return requestGooseAPI<{ results: InvoiceClientDto[]; nextToken: string | null }>({
      url: getAPIPath(CLIENT_INVOICES_BY_PERIOD, { locationId: locationName }),
      method: 'GET',
      params: {
        ...options,
        includes: [...includesList],
        includeShared,
      },
    })
  },
}
